export default __webpack_public_path__ + "static/media/img-0666-albania-full-face.32f69f09.png";